import { Flex, HStack, chakra } from '@chakra-ui/react';
import React from 'react';

import type { PaginationParams } from 'ui/shared/pagination/types';

import ActionBar from 'ui/shared/ActionBar';
import Pagination from 'ui/shared/pagination/Pagination';

type Props = {
  paginationProps: PaginationParams;
  className?: string;
  showPagination?: boolean;
  filterComponent?: React.ReactNode;
  linkSlot?: React.ReactNode;
  linkSlotPosition?: 'inline' | 'belowPagination';
};

const TxsHeaderMobile = ({
  filterComponent,
  paginationProps,
  className,
  showPagination = true,
  linkSlot,
  linkSlotPosition = 'inline',
}: Props) => {
  return (
    <ActionBar className={ className }>
      <Flex direction="column" w="100%">
        <HStack w="100%" justifyContent="space-between" alignItems="stretch" spacing={ 0 }>
          <HStack data-testid="txs-header-mobile-main-row" flexWrap="wrap">
            { filterComponent }
            { linkSlotPosition === 'inline' && linkSlot }
          </HStack>
          { showPagination && <Pagination { ...paginationProps }/> }
        </HStack>
        { linkSlotPosition === 'belowPagination' && linkSlot && (
          <HStack data-testid="txs-header-mobile-bottom-row" w="100%" justifyContent="flex-end" mt={ 3 }>
            { linkSlot }
          </HStack>
        ) }
      </Flex>
    </ActionBar>
  );
};

export default chakra(TxsHeaderMobile);
